import type { CookieRecord } from '#src/services/cookieTranslationService/types.ts'

type CookieControllerGroup = {
  dataController: string
  privacyLink: string
  cookies: CookieRecord[]
}

export function getCookieControllerGroups(
  cookies: CookieRecord[],
): CookieControllerGroup[] {
  const groupsByController = new Map<string, CookieControllerGroup>()

  for (const cookie of cookies) {
    const dataController = cookie.dataController || '-'
    const existingGroup = groupsByController.get(dataController)

    if (!existingGroup) {
      groupsByController.set(dataController, {
        dataController,
        privacyLink: cookie.privacyLink,
        cookies: [cookie],
      })
      continue
    }

    existingGroup.cookies.push(cookie)
    if (!existingGroup.privacyLink && cookie.privacyLink) {
      existingGroup.privacyLink = cookie.privacyLink
    }
  }

  return Array.from(groupsByController.values())
}
